import { AlertCircle, RotateCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import LoadingSpinner from "@/components/LoadingSpinner";

interface ErrorMessageWidgetProps {
  errorMessage?: string;
  isLoading?: boolean;
  onRetry?: () => void;
}

export const ErrorMessageWidget = ({
  errorMessage,
  isLoading = false,
  onRetry,
}: ErrorMessageWidgetProps) => (
  <div className="my-2 duration-200 animate-in fade-in-0 slide-in-from-top-2">
    <div
      className="relative flex items-start gap-2 rounded-lg border border-red-200/60 bg-gradient-to-br from-red-50/50 to-red-50/30 p-2.5 shadow-sm backdrop-blur-sm"
      role="alert"
      aria-live="polite"
    >
      <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100/80 ring-1 ring-red-200/50">
        <AlertCircle className="h-3.5 w-3.5 text-red-600" aria-hidden="true" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <div className="flex items-start justify-between gap-2">
          <div>
            <h4 className="text-sm font-semibold text-red-900">Request failed</h4>
            {errorMessage && (
              <p className="mt-0.5 text-xs leading-relaxed text-red-700/90">{errorMessage}</p>
            )}
          </div>
        </div>

        {onRetry && (
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              disabled={isLoading}
              className="h-7 border-red-200 bg-white/80 text-xs font-medium text-red-700 shadow-sm transition-all hover:border-red-300 hover:bg-red-50 hover:text-red-800 focus-visible:ring-2 focus-visible:ring-red-500/20 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isLoading ? (
                <div className="flex items-center gap-1">
                  <LoadingSpinner size={3} />
                  Retrying...
                </div>
              ) : (
                <div className="flex items-center gap-1">
                  <RotateCw className="mr-1.5 h-3 w-3" />
                  Retry
                </div>
              )}
            </Button>
          </div>
        )}
      </div>
    </div>
  </div>
);
